<template>
  <v-container class="col-12">
    <v-data-table
      :loading="loading"
      loading-text="Loading..."
      :headers="headers"
      :items="items"
      :items-per-page="-1"
      class="postback-dt"
      width="100%"
      height="calc(100vh - 24px)"
      fixed-header
      hide-default-footer
    >
      <template v-slot:item.actions="{ headers , item: postback }">

        <v-btn
          v-if="$store.state.auth.checkAccess({key: 'postbacks_update', value: true})"
          @click="dialog = true; item = Object.assign({}, postback)"
          x-small
          color="success"
          fab
          width="28px"
          height="28px"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <template v-slot:body.prepend>
        <tr v-if="Object.keys(filters).length > 0" class="postback-filter-row grey lighten-3">
          <td
            v-for="header in headers"
            :key="header.text"
          >
            <v-select
              v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
              hide-details
              dense
              small
              multiple
              clearable
              persistent-hint
              single-line
              class="data-table-finance-filter-select mt-0"
              :items="filters[header.value].values || columnValueList(header.value)"
              :style="{width: (filters[header.value] || {width: false}).width}"
              v-model="filters[header.value].data"
            ></v-select>
            <v-text-field
              class="data-table-finance-filter-textfield"
              v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
              v-model="filters[header.value].data"
              :style="{'max-width': (filters[header.value] || {width: false}).width}"
              hide-details
            ></v-text-field>

            <v-btn
              v-if="header.value == 'actions' && $store.state.auth.checkAccess({key: 'postbacks_update', value: true})"
              @click="dialog = true; item = {new: true}"
              x-small
              color="success"
              fab
              width="28px"
              height="28px"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog
      v-if="$store.state.auth.checkAccess({key: 'postbacks_update', value: true})"
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{ item.new ? 'Create Postback' : 'Update Postback' }}
        </v-card-title>

        <v-card-text class="">
          <v-form ref="postback-edit-form" v-model="valid">
            <v-row class="ma-0 pa-0">
              <template v-for="field in fields">
                <v-text-field
                  v-if="!field.type"
                  :key="field.text"
                  v-model="item[field.value]"
                  :label="field.text"
                  :class="field.class"
                  :rules="field.rules"
                  hide-details
                />
                <v-select
                  v-if="field.type == 'select'"
                  hide-details
                  single-line
                  :label="field.text"
                  :class="field.class"
                  :key="field.text"
                  :items="field.values || columnValueList(field.value)"
                  :rules="field.rules"
                  v-model="item[field.value]"
                />
                <v-combobox
                  v-if="field.type == 'combobox'"
                  hide-details
                  single-line
                  :return-object="false"
                  auto-select-first
                  :item-value="field['item-value']"
                  :item-text="field['item-text']"
                  :label="field.text"
                  :class="field.class"
                  :multiple="field.multiple"
                  :key="field.text"
                  :items="field.values || columnValueList(field.value)"
                  :rules="field.rules"
                  v-model="item[field.value]"
                />
              </template>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            @click="save()"
            small
            color="primary"
          >
            Save
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            @click="role = {}; dialog = false;"
            color="warning"
            small
          >
            Close
          </v-btn>

        </v-card-actions>

      </v-card>
    </v-dialog>
  </v-container>
</template>

<style>

  .postback-dt tr:not(.report-filter-row) {
    counter-increment: row-num;
  }

  .postback-dt tr td:first-child .row_num::before {
    content: counter(row-num) ". ";
  }

  .postback-filter-row td {
    height: 32px!important;
  }


  .data-table-finance-filter-textfield input {
    /*text-align: center;*/
  }

  .data-table-finance-filter-textfield {
    max-width: 80px;
    font-size: 12px;
    padding: 0;
    margin: 0;
  }


  .data-table-finance-filter-select .v-select__selections {
    height: 32px;
    overflow: hidden;
    white-space: nowrap;
  }
</style>

<script>
  import { map } from 'lodash'
  import { API } from '@/utils/api'

  export default {
    data: () => ({
      dialog: false,
      valid: false,
      loading: false,
      headers: [
        {
          sortable: true,
          text: 'ID',
          value: 'postback_settings_id'
        },
        {
          sortable: false,
          text: 'Project',
          value: 'project'
        },
        {
          sortable: false,
          text: 'Affid',
          value: 'affid'
        },
        {
          sortable: false,
          text: 'Action',
          value: 'action'
        },
        {
          sortable: false,
          text: 'URL',
          value: 'url'
        },
        {
          sortable: false,
          text: 'Status',
          value: 'status'
        },
        {
          sortable: true,
          text: 'Created',
          value: 'created'
        },
        {
          sortable: true,
          text: 'Updated',
          value: 'updated'
        },
        {
          sortable: false,
          text: '',
          value: 'actions'
        }
      ],
      fields: {
        project: {
          text: 'Project',
          value: 'entity_id',
          values: [],
          type: 'select',
          class: 'col-12 px-0',
          rules: [ v => !!v || 'Project is required' ]
        },
        affid: {
          text: 'Affid',
          value: 'affid',
          class: 'col-12 px-0',
          rules: [ v => !!v || 'AffID is required' ],
        },
        min_deposit: {
          text: 'Min Deposit (EUR)',
          value: 'min_deposit',
          class: 'col-6 pl-0',
          rules: [],
        },
        max_deposit: {
          text: 'Max Deposit (EUR)',
          value: 'max_deposit',
          class: 'col-6 pr-0',
          rules: [],
        },
        country: {
          text: 'Country',
          value: 'country',
          'item-value': 'code',
          'item-text': 'title',
          class: 'col-6 pl-0',
          type: 'combobox',
          values: [],
          rules: [],
        },
        exclude_countries: {
          text: 'Exclude countries',
          value: 'exclude_countries',
          'item-value': 'code',
          'item-text': 'title',
          type: 'combobox',
          values: [],
          multiple: true,
          class: 'col-6 pr-0',
          rules: [],
        },
        action: {
          text: 'Action',
          value: 'action',
          values: [ 'registration', 'first_deposit', 'deposit', 'login', 'visit' ],
          type: 'select',
          class: 'col-12 px-0',
          rules: [ v => !!v || 'Action is required' ],
        },
        url: {
          text: 'URL',
          value: 'url',
          class: 'col-12 px-0',
          rules: [ v => !!v || 'URL is required' ],
        },
        status: {
          text: 'Status',
          value: 'status',
          type: 'select',
          values: [ 'active', 'disabled' ],
          class: 'col-12 px-0',
          rules: [ v => !!v || 'Status is required' ],
        },
      },
      filters: {
        postback_settings_id: { data: [], type: 'text' },
        project: { data: [], type: 'select' },
        status: { data: [], type: 'select' },
        action: { data: [], type: 'select' },
        affid: { data: [], type: 'text' },
        url: { data: [], type: 'text', width: '100%' },
      },
      items: [],
      item: {}
    }),

    mounted () {
      this.fields.project.values = map(this.$store.state.auth.entities, (i) => ({ text: i.name, value: i.entity_id }))
      this.fields.exclude_countries.values = this.$store.state.app.countries
      this.fields.country.values = this.$store.state.app.countries
      this.load()
    },

    methods: {
      async save () {
        if (this.loading || !this.$refs['postback-edit-form'].validate()) return
        if (await this.$root.$confirm('Confirm', !this.item.new ? 'Save changes' : 'Add postback')) {
          this.loading = true
          API.call('/$v/affiliate/postback/update.json', {
            postback: this.item
          }, null, this.item.entity_id).then(resp => {
            this.$notification.show = true
            this.$notification.message = `Postback ${!this.item.new ? 'updated' : 'created'}`
            this.$notification.type = 'success'

            this.dialog = false
            this.item = {}

            return this.load()
          }).finally(() => {
            this.loading = false
          })
        }
      },
      load () {
        this.loading = true
        API.call('/$v/affiliate/postback/list.json', {}).then(resp => {
          this.items = resp.data
        }).finally(() => {
          this.loading = false
        })
      },
      columnValueList (val) {
        return this.items.map(d => d[val])
      }
    }
  }
</script>
